// extracted by mini-css-extract-plugin
export default {"dialogCard":"NotificationHistoryDialog_dialogCard__-dw1S","form":"NotificationHistoryDialog_form__7sYEo"};